import React from 'react'
import PropTypes from 'prop-types'
import { ListGroup } from 'react-bootstrap'

class ListView extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      selected: []
    }
  }

  onItemClick = value => {
    if (this.props.multiple) {
      const copy = this.state.selected.slice(0)
      const idx = copy.indexOf(value)
      if (idx === -1) {
        copy.push(value)
      } else {
        copy.splice(idx, 1)
      }
      this.props.onSelect(copy)
      this.setState({ selected: copy })
    } else {
      this.props.onSelect(value)
      this.setState({ selected: [value] })
    }
  }

  render() {
    return (
      <ListGroup>
        {
          this.props.children.map(child => React.cloneElement(child,
            {
              onItemClick: this.onItemClick,
              multiple: this.props.multiple,
              checked: this.state.selected.indexOf(child.props.eventKey) !== -1
            })
          )
        }
      </ListGroup>
    )
  }
}

ListView.defaultProps = {
  multiple: false,
  onSelect: () => {}
}

ListView.propTypes = {
  multiple: PropTypes.bool,
  onSelect: PropTypes.func,
}

export default ListView



// WEBPACK FOOTER //
// ./src/components/widgets/ListView.js